import React from 'react';

import { sanitizeHtml } from '../lib/sanitizeHtml';

function SafeHtml({ html, className, as: As = 'span', ...props }) {
  const safe = sanitizeHtml(html);
  return <As className={className} dangerouslySetInnerHTML={{ __html: safe }} {...props} />;
}

export default SafeHtml;
